(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSSector', SSSector);

    SSSector.$inject = ['$resource', 'DateUtils'];

    function SSSector ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
